import { Button, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { Cancel } from 'app/components/Common/CancelModal/Cancel';
import { postLandGtgDetails } from 'app/services/PlacementServices/PlacementServices';
import { selectUser } from 'oidc/user.selectors';
import { userRoles } from 'oidc/userRoles';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsLicenseSelect,
  selectLandGtgCompletionStatus,
  selectMiscellaneousPlacementData,
  selectPlacementHeaderData,
  selectPlacementLandsGtgDetails,
} from '../../../../../../store/redux-store/placement-details/selectors';
import { LANDSGTGWrapper } from './LANDSGTGWrapper';
import { placementDetailsAction } from '../../../../../../store/redux-store/placement-details/slice';
import moment from 'moment';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import { useParams } from 'react-router-dom';
import { ILandsGtgDetailsPost } from 'app/models/Placement/PlacementDetails';
import { getStateDesc } from './LandsSections/LandsFormHelper';
import { convertToFormat } from 'app/helpers/dateHelper';
import { Authorized } from 'oidc/userHelper';
import { useTranslation } from 'react-i18next';
import LandsGtgPopup from './LandsSections/LandsGtgPopup';

const useStyles = makeStyles()({
  actionNoBtn: {
    color: '#ffffff !important',
    backgroundColor: '#8E9195 !important',
    width: '106px',
    height: '40px',
  },
  primaryBtn: {
    margin: '0px  25px',
  },
});

const nursysReasonDefaultValue = value => {
  if (
    value == 'Nursys verification is only required for RN and LPN licenses' ||
    value == 'Nursys verification is not required in Michigan'
  ) {
    return '';
  } else {
    return value;
  }
};

export const LANDSGTGTab = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const LandsGtgDetails = useSelector(selectPlacementLandsGtgDetails);
  const selRequirementId = useSelector(selectIsLicenseSelect);
  const { licensesList } = useSelector(selectMiscellaneousPlacementData);
  const landsGtgCompletionStatus = useSelector(selectLandGtgCompletionStatus);
  const placementHeaderInfo = useSelector(selectPlacementHeaderData);
  const isFinalizedByQS = placementHeaderInfo.isFinalizedByQS;
  const [open, setOpen] = useState<boolean>(false);
  const isLandsGtgCompleted = LandsGtgDetails?.isgtgComplete && LandsGtgDetails?.isLandsComplete;

  const [cancel, setCancel] = useState<boolean>(false);
  const [hasEditPermission, setHasEditPermission] = React.useState(false);
  const [supportList, setSupportList] = useState<any[]>([]);
  const params = useParams<{ placementId: string }>();
  const placementId = parseInt(params.placementId);
  const [waveandexList, setWaveandexList] = useState<any[]>([]);
  const [notRequiredReasonsList, setNotRequiredReasonsList] = React.useState<any[]>([]);
  const [landsNotRequiredReasonsList, setLandsNotRequiredReasonsList] = React.useState<any[]>([]);
  const [cancelClicked, setCancelClicked] = useState(false);
  //initial Data
  const InitalData = {
    pCrossReferenced: LandsGtgDetails?.crimCheckDate ? true : false,
    pDateOfValidation: LandsGtgDetails?.crimCheckDate,
    pI9OnFIle: LandsGtgDetails?.i9Uploaded,
    pSupportDocOnFile: LandsGtgDetails?.supportDocUploaded,
    pNamesAndNumbersMatch: LandsGtgDetails?.namesNumbersMatchI9,
    pEVerifyCode: LandsGtgDetails?.i9eVerifyCode,
    pEVerifyUpload: LandsGtgDetails?.eVerifyDate,
    pNotAForeignTraveler: LandsGtgDetails?.notForeignTraveler,
    pExceptionFollowUpDate: LandsGtgDetails?.foreignTravelerFUDate,
    pSupportDocList: supportList?.find(x => x.Id === LandsGtgDetails?.supportDocListId?.toString())?.Description,
    pExceptionWaiveEvent: LandsGtgDetails?.missExpEvents,
    pFinalAuditCompleted: LandsGtgDetails?.i9FinalAuditCompleted,
    pReason: LandsGtgDetails?.checkStateReason,
    pNotRequiredReasonId: LandsGtgDetails?.gtgNotRequiredReasonId,
    pNotRequiredReason: LandsGtgDetails?.gtgNotRequiredReason,
    piExWave: waveandexList?.find(x => x.Id === LandsGtgDetails?.checkStateExceptId?.toString())?.Description,
    pYes: LandsGtgDetails?.checkState,
    pExpYes: LandsGtgDetails?.noExpAssign,
    pEventsSet: LandsGtgDetails?.missExpEvents,
    AllVerified: LandsGtgDetails?.allCertificationsVerified,
    pClientYes: LandsGtgDetails?.packetNotRequired,
    pSentToClient: LandsGtgDetails?.packetSentDate,
    licenseActive: LandsGtgDetails?.licenseActive,
    licenseReviewCleared: LandsGtgDetails?.licenseReviewTeamClearedHits,
    licenseMatchAudit: LandsGtgDetails?.hitsOnLicenseMatchAudit,
    auditScreened: LandsGtgDetails?.auditScreenedWithClient,
    datesCheckbox1: LandsGtgDetails?.licenseIssuedAfterGraduation,
    datesCheckbox2: LandsGtgDetails?.checkedDob,
    datesCheckbox3: LandsGtgDetails?.confirmCaLicense,
    reason: LandsGtgDetails?.confirmCaLicenseReason,
    proofOfResidency: LandsGtgDetails?.isProofOfResidencyOnFileForCompact,
    pSingleYes: (!LandsGtgDetails?.isAlliedClinician && LandsGtgDetails?.statesInNursys) || false,
    pSingleNo: LandsGtgDetails?.statesInNursys || false,
    pAddressesYes: (!LandsGtgDetails?.isAlliedClinician && LandsGtgDetails?.nursysMatchOnFile) || false,
    pAddressesNo: LandsGtgDetails?.nursysMatchOnFile || false,
    pMatchesYes: (!LandsGtgDetails?.isAlliedClinician && LandsGtgDetails?.nursysLastnameMatchesLicense) || false,
    pMatchesNo: LandsGtgDetails?.nursysLastnameMatchesLicense || false,
    pSingleReason: nursysReasonDefaultValue(LandsGtgDetails?.statesInNursysReason) || '',
    pAddressesReason: nursysReasonDefaultValue(LandsGtgDetails?.nursysMatchOnFileReason) || '',
    pMatchesReason: nursysReasonDefaultValue(LandsGtgDetails?.nursysLastnameNotMatchesLicenseReason) || '',
  };
  const formMethods = useForm({ mode: 'all', defaultValues: InitalData });
  const {
    handleSubmit,
    setValue,
    reset,
    setError,
    formState: { dirtyFields, isDirty },
  } = formMethods;

  useEffect(() => {
    if (supportList.length === 0) {
      fetchList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supportList]);
  const fetchList = async () => {
    var result = await getSearchFilterOptions('LANDSupportDocList');
    var tempList = result?.map(x => {
      return {
        Id: x.value,
        Description: x.name,
      };
    });
    if (tempList) {
      setSupportList(tempList);
    }
    setValue(
      'pSupportDocList',
      tempList?.find(x => x.Id === LandsGtgDetails?.supportDocListId?.toString())?.Description,
    );
  };

  useEffect(() => {
    if (waveandexList.length === 0) {
      fetchWaveandexList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waveandexList]);

  const fetchWaveandexList = async () => {
    var result = await getSearchFilterOptions('LANDCheckStateExcept');
    var tempList = result?.map(x => {
      return {
        Id: x.value,
        Description: x.name,
      };
    });
    if (tempList) {
      setWaveandexList(tempList);
    }
    setValue(
      'piExWave',
      tempList?.find(x => x.Id === LandsGtgDetails?.checkStateExceptId?.toString())?.Description,
      {},
    );
  };

  useEffect(() => {
    if (notRequiredReasonsList?.length === 0) {
      fetchNotRequiredReasonsList();
    }
    if (landsNotRequiredReasonsList?.length === 0) {
      fetchLandsNotRequiredReasonsList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notRequiredReasonsList]);

  const fetchNotRequiredReasonsList = async () => {
    var result = await getSearchFilterOptions('LANDGTGNotRequiredReason');
    var tempList = result?.map(x => {
      return {
        Id: x.value,
        Description: x.name,
      };
    });
    if (tempList) {
      setNotRequiredReasonsList(tempList);
    }
  };

  const fetchLandsNotRequiredReasonsList = async () => {
    var result = await getSearchFilterOptions('LANDNotRequiredReason');
    var tempList = result?.map(x => {
      return {
        Id: x.value,
        Description: x.name,
      };
    });
    if (tempList) {
      setLandsNotRequiredReasonsList(tempList);
    }
  };

  useEffect(() => {
    setHasEditPermission(
      Authorized(
        [userRoles.credentialing_Leadership, userRoles.credentialing_TeamMember],
        user.userInfo,
      ),
    );
    dispatch(placementDetailsAction.setIsLandsCancel(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    return () => {
      dispatch(placementDetailsAction.setIsLandsCancel(false));
      setCancelClicked(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cancelClicked]);
  const onError = (errors, e) => {
    console.log('error saving data', errors);
  };
  const changedFieldsArray = Object.keys(dirtyFields).filter(k => !k.startsWith('License_'));

  const nursysReason = selectedLicense => {
    if (selectedLicense && selectedLicense.requirementTypeID !== 147 && selectedLicense.requirementTypeID !== 146) {
      return t('placement.profile.tabs.LANDS/GTGTab.nursysVerificationOnlyRequiredLicenses');
    }
    if (
      selectedLicense &&
      (selectedLicense.requirementTypeID === 147 || selectedLicense.requirementTypeID === 146) &&
      selectedLicense.stateID === 23
    ) {
      return t('placement.profile.tabs.LANDS/GTGTab.nursysVerificationNotRequiredMichigan');
    } else {
      return null;
    }
  };

  const validate = data => {
    let isFormValid = true;
    if (data?.piLicenseComment && data.piLicenseComment?.length > 200) {
      setError('piLicenseComment', {
        type: 'maxLength',
        message: t('placement.profile.tabs.LANDS/GTGTab.maxLengthMessage'),
      });
      isFormValid = false;
    }
    if (data?.pNotRequiredReason && data.pNotRequiredReason?.length > 200) {
      setError('pNotRequiredReason', {
        type: 'maxLength',
        message: t('placement.profile.tabs.LANDS/GTGTab.maxLengthMessage'),
      });
      isFormValid = false;
    }
    return isFormValid;
  };

  const onSubmit = async (data, e) => {
    const filterByRequirementIDList = licensesList?.filter(d => d.requirementID === selRequirementId) || [];
    const filterByRequirementIDListApiData =
      licensesList?.filter(d => d.licenseNumber === LandsGtgDetails?.licenseNumber) || [];
    if (validate(data)) {
      var bodyPayload: ILandsGtgDetailsPost = {
        placementId: LandsGtgDetails?.placementId || placementId,
        notRequired:
          data?.piLicenseRequired !== null || data?.piLicenseRequired !== undefined
            ? data?.piLicenseRequired
            : LandsGtgDetails?.notRequired || false,
        notRequiredReasonId: landsNotRequiredReasonsList?.find(x => x.Description === data?.piLicenseReason)?.Id
          ? parseInt(landsNotRequiredReasonsList?.find(x => x.Description === data?.piLicenseReason)?.Id)
          : LandsGtgDetails?.notRequiredReasonId || null,
        notRequiredReason: data?.piLicenseComment || '',
        licenseNumber: filterByRequirementIDList[0]?.licenseNumber || null,
        licenseActive: data?.licenseActive || false,
        licenseReviewTeamClearedHits: data?.licenseReviewCleared || false,
        hitsOnLicenseMatchAudit: data?.licenseMatchAudit || false,
        auditScreenedWithClient: data?.auditScreened || false,
        statesInNursys: data?.pSingleYes || false,
        statesInNursysReason: data?.pSingleReason || nursysReason(filterByRequirementIDList[0]),
        nursysMatchOnFile: data?.pAddressesYes || false,
        licenseIssuedAfterGraduation: data?.datesCheckbox1 || false,
        checkedDob: data?.datesCheckbox2 || false,
        expirationDate: filterByRequirementIDList[0]?.expirationDate
          ? moment(filterByRequirementIDList[0]?.expirationDate).format('yyyy-MM-DD')
          : null,
        typeId: filterByRequirementIDList[0]?.typeID || null,
        levelId: filterByRequirementIDList[0]?.levelID === 307 ? 6 : 7 || null,
        discMatchAssign: LandsGtgDetails?.discMatchAssign || false,
        lastUpdated: convertToFormat(new Date(), 'YYYY-MM-DDTHH:mm:ss.SSS', true) || null,
        lastUpdatedByUserId: user?.userInfo?.employeeId || 8410,
        lastUpdatedByName: {
          first: user.userInfo?.firstName || null,
          last: user.userInfo?.lastName || null,
        },
        timestamp: LandsGtgDetails?.timestamp || null,
        cabreezeAct: LandsGtgDetails?.cabreezeAct || null,
        confirmCaLicense: data?.datesCheckbox3 || false,
        confirmCaLicenseReason: data?.reason || null,
        isLandsComplete: data?.piLicenseRequired
          ? data?.piLicenseRequired
          : landsGtgCompletionStatus?.landsStatus || false,
        gtgNotRequired: LandsGtgDetails?.gtgNotRequired || false,
        gtgNotRequiredReasonId: notRequiredReasonsList?.find(x => x.Description === data.pNotRequiredReasonId)?.Id
          ? parseInt(notRequiredReasonsList?.find(x => x.Description === data.pNotRequiredReasonId)?.Id)
          : LandsGtgDetails?.gtgNotRequiredReasonId
          ? LandsGtgDetails?.gtgNotRequiredReasonId
          : null,
        gtgNotRequiredReason: data?.pNotRequiredReason || '',
        crimCheckDate: data.pDateOfValidation ? moment(data.pDateOfValidation).format('yyyy-MM-DD') : null,
        i9Uploaded: data.pI9OnFIle || false,
        supportDocListId: supportList?.find(x => x.Description === data.pSupportDocList)?.Id
          ? parseInt(supportList?.find(x => x.Description === data.pSupportDocList)?.Id)
          : null,
        supportDocUploaded: data.pSupportDocOnFile || false,
        namesNumbersMatchI9: data.pNamesAndNumbersMatch || false,
        eVerifyDate: data.pEVerifyUpload ? moment(data.pEVerifyUpload).format('yyyy-MM-DD') : null,
        notForeignTraveler: data.pNotAForeignTraveler || false,
        foreignTravelerFUDate: data.pExceptionFollowUpDate
          ? moment(data.pExceptionFollowUpDate).format('yyyy-MM-DD')
          : null,
        foreignTravelerEvent: data.pExceptionWaiveEvent || false,
        checkState: data.pYes || false,
        checkStateReason: data.pReason || null,
        checkStateExceptId: waveandexList?.find(x => x.Description === data.piExWave)?.Id
          ? parseInt(waveandexList?.find(x => x.Description === data.piExWave)?.Id)
          : null,
        missExpEvents: data.pEventsSet || false,
        noExpAssign: data.pExpYes || false,
        packetSentDate: data.pSentToClient ? moment(data.pSentToClient).format('yyyy-MM-DD') : null,
        packetNotRequired: data.pClientYes || false,
        gtgLastUpdated: convertToFormat(new Date(), 'YYYY-MM-DDTHH:mm:ss.SSS', true) || null,
        gtgLastUpdatedByUserId: user.userInfo?.employeeId || 8410,
        gtgLastUpdatedByName: {
          first: user.userInfo?.firstName || null,
          last: user.userInfo?.lastName || null,
        },
        isgtgComplete: landsGtgCompletionStatus?.gtgStatus || false,
        i9FinalAuditCompleted: data.pFinalAuditCompleted || false,
        i9eVerifyCode: data.pEVerifyCode || null,
        allCertificationsVerified: data.pAllVerified || false,
        licenseStateProvinceId: filterByRequirementIDList[0]?.stateID.toString() || null,
        licenseStateProvice: filterByRequirementIDList[0]?.licenseStateProvice
          ? filterByRequirementIDList[0]?.licenseStateProvice
          : getStateDesc(filterByRequirementIDList[0]?.stateID) || null,
        isAlliedClinician:
          (LandsGtgDetails?.isAlliedClinician &&
            filterByRequirementIDList[0]?.licenseNumber == LandsGtgDetails?.licenseNumber) ||
          (filterByRequirementIDList[0]?.requirementTypeID !== 147 &&
            filterByRequirementIDList[0]?.requirementTypeID !== 146) ||
          false,
        nursysLastnameMatchesLicense: data?.pMatchesYes || false,
        nursysLastnameNotMatchesLicenseReason: data?.pMatchesReason || nursysReason(filterByRequirementIDList[0]),
        isProofOfResidencyOnFileForCompact: data?.proofOfResidency || false,
        nursysMatchOnFileReason: data?.pAddressesReason || nursysReason(filterByRequirementIDList[0]),
        currentEmployeeId: user.userInfo?.employeeId || 8410,
        //fields for change history log
        licenseRequirementTypeId: filterByRequirementIDList[0]?.requirementTypeID, //to check RN or LPN License
        amnDivisionSelected: placementHeaderInfo.facility.amnDivisionType, //to check for Allied divison
        oldLicenceName: filterByRequirementIDListApiData[0]?.credentialName,
        newLicenceName: filterByRequirementIDList[0]?.credentialName,
        checkStateExceptNewName: waveandexList?.find(x => x.Description === data.piExWave)?.Description,
        checkStateExceptOldName: waveandexList?.find(x => x.Id === LandsGtgDetails?.checkStateExceptId?.toString())
          ?.Description,

        supportDocListOldName: supportList?.find(x => x.Id === LandsGtgDetails?.supportDocListId?.toString())
          ?.Description,
        supportDocListNewName: supportList?.find(x => x.Description === data.pSupportDocList)?.Description,
      };
      if (isFinalizedByQS && !(bodyPayload?.isLandsComplete && bodyPayload?.isgtgComplete))
        dispatch(placementDetailsAction.updateFinalizedByQs());
      var response = await postLandGtgDetails(bodyPayload);
      if (response?.status === 200) {
        dispatch(
          globalActions.setSnackBar({
            message: t('placement.profile.tabs.LANDS/GTGTab.postLandGtgDetailsSucessMessage'),
            severity: 'success',
          }),
        );
        dispatch(placementDetailsAction.setLandsGtgDetails(response.data));
      } else {
        dispatch(
          globalActions.setSnackBar({
            message: t('placement.profile.tabs.LANDS/GTGTab.postLandGtgDetailsErrorMessage'),
            severity: 'error',
          }),
        );
      }
    }
    //save logic here
  };
  const handleCancel = () => {
    if (changedFieldsArray.length > 0) setCancel(true);
  };
  const yesAction = () => {
    reset(InitalData);
    dispatch(placementDetailsAction.setIsLandsCancel(true));
    setCancelClicked(true);
    setCancel(false);
  };
  const noAction = () => {
    setCancel(false);
  };

  useEffect(() => {
    if (isFinalizedByQS && isLandsGtgCompleted && isDirty) {
      setOpen(true);
    }
  }, [isLandsGtgCompleted, isFinalizedByQS, isDirty]);

  return (
    <>
      {hasEditPermission && <LandsGtgPopup open={open} setDialogOpen={() => setOpen(false)} />}
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <LANDSGTGWrapper
            hasEditPermission={hasEditPermission}
            supportList={supportList}
            waveandexList={waveandexList}
            cancel={cancel}
          />
          <Grid item style={{ textAlign: 'end', marginTop: '25px' }}>
            <Button
              onClick={handleCancel}
              disableRipple
              disableFocusRipple
              disabled={!hasEditPermission}
              color="tertiary"
              size="large"
              variant="contained"
              data-testid="secondary-button-id"
            >
              {t('placement.profile.tabs.LANDS/GTGTab.cancelBtn')}
            </Button>

            <Button
              //   onClick={() => {}}
              disableRipple
              disableFocusRipple
              disabled={!hasEditPermission || changedFieldsArray.length < 1}
              className={classes.primaryBtn}
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              data-testid="secondary-button-id"
            >
              {t('placement.profile.tabs.LANDS/GTGTab.saveBtn')}
            </Button>
          </Grid>
          {cancel && <Cancel openDialog={cancel} handleConfirmAction={yesAction} handleCancelAction={noAction} />}
        </form>
      </FormProvider>
    </>
  );
};
